import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { DataService } from "src/app/http/data.service";
import { authData, promiseAuthData } from "src/app/util/auth";
import { errorHandler } from "src/app/util/errorHandler";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-dashboard-index",
  templateUrl: "./dashboard-index.component.html",
})
export class DashboardIndexComponent implements OnInit {
  constructor(
    private httpClient: HttpClient,
    private router: Router,
    private dataService: DataService
  ) {}

  links: Link[] = [
    {
      title: "Basic Data",
      slug: "/bio-data/basic",
      icon: "/assets/icons/visa.png",
      text: "Add a line or two here that explains what this card does",
    },
    {
      title: "Update Passport",
      slug: "/bio-data/passport",
      icon: "/assets/icons/photo.png",
      text: "Add a line or two here that explains what this card does",
    },];
  payload: any = [];
  notification = {};
  _auth = authData();
  _sliderData = authData("_slider");
  _checks = authData("_checks");
  _isApplication = authData("_isApplication");
  showPopup = false;
  dialog = false;

  httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + authData().Token,
    }),
  };

  async ngOnInit(): Promise<void> {
    const message: string = location.hash.slice(1);
    if (message) {
      let messageContent = message.split("#");
      this.notification = {
        error: !(messageContent.length > 1 && messageContent[1] == "success"),
        message: messageContent[0].replace("%20", " ").replace(/\+/g, " "),
      };
    }

    this.links.push({
      title: "Payments",
      slug: "/payments",
      icon: "/assets/icons/credit-card.png",
      text: "Add a line or two here that explains what this card does",
    });

    // this.links.push({
    //   title: "Applications",
    //   slug: "/application",
    //   icon: "/assets/icons/homework.png",
    //   text: "Add a line or two here that explains what this card does",
    // });

    // this.links.push({
    //   title: "Student Data",
    //   slug: "/bio-data",
    //   icon: "/assets/icons/visa.png",
    //   text: "Add a line or two here that explains what this card does",
    // });
    if (this._checks !== null && Object.keys(this._checks).length === 0) {
        this.dataService.fetchChecks(this._isApplication).subscribe((res: any) => {
          if (res?.Success) {
            if (res.Data.ShowAcceptance) {
              // this.links.push({
              //   title: "Acceptance",
              //   slug: "/application/acceptance",
              //   icon: "/assets/icons/view100.png",
              //   text: "Add a line or two here that explains what this card does",
              // });
            }
          }
        });
    } else {
      if (this._checks.ShowAcceptance) {
        // this.links.push({
        //   title: "Acceptance",
        //   slug: "/application/acceptance",
        //   icon: "/assets/icons/view100.png",
        //   text: "Add a line or two here that explains what this card does",
        // });
      }
    }
    // this.links.push({
    //   title: "Student Data",
    //   slug: "/bio-data",
    //   icon: "/assets/icons/visa.png",
    //   text: "Add a line or two here that explains what this card does",
    // });
    if (
      this._sliderData !== null &&
      Object.keys(this._sliderData).length === 0
    ) {
      this.dataService.fetchSlider().subscribe(
        (res: any) => {
          if (res?.Data?.length == 0) {
            this.payload = false;
          } else {
            this.payload = res?.Data;
          }
        }
        // (err) => {
        //   this.notification = {
        //     message: err.message || "An error occured in the slider",
        //     error: true,
        //   };
        // }
      );
    } else {
      this.payload = this._sliderData;
    }
    if (this._auth.ShowBiodataPopup) this.showPopup = true;
  }

  onOkClicked(bioerr: any) {
    this.showPopup = false;

    if (bioerr) {
      this.notification = {
        error: true,
        message: bioerr,
      };
    }
  }
  refreshPayment(): void {
    this.notification = {};
    this.dialog = true;

    const baseUrl = `${environment.BASE_URL}/payments/refereshStatus`;
    this.httpClient.get(baseUrl, this.httpOptions).subscribe({
      next: (res: any) => {
        this.dialog = false;
        this.payload = res.Data;
        this.notification = {
          error: false,
          message: "Payment refreshed successfully",
        };
      },
      error: (err) => {
        this.dialog = false;
        this.notification = errorHandler(err);
      },
    });
  }
}

interface Link {
  title: string;
  slug: string;
  icon: string;
  text: string;
}
